'use strict';
import Immutable from 'immutable';
import createSelector from './createSelector';
import resourceSelector from './resourceSelector';
import cacheSelector from './cacheSelector';
import { resolveResource } from './resolve';



export const envSelector													= (state) => state.getIn(['env'], Immutable.Map());
export const resourceExists												= (state, type, id) => state.hasIn(['resources', type, id.toString()]);
export const articleExists												= (state, id) => state.hasIn(['resources', 'articles', id.toString()]);
export const programExists												= (state, id) => state.hasIn(['resources', 'programs', id.toString()]);
export const frontpageExists											= (state) => state.hasIn(['resources', 'pages', 'frontpage']);
export const pageErrorExists											= (state) => state.hasIn(['resources', 'pages', state.get('selected'), 'error']);
export const selectedResourceCacheControlSelector = (state) => state.getIn(['resources', state.get('selectedResource'), 'meta', 'cache-control'], false);
export const selectedResourceTypeSelector					= (state) => state.getIn(['application', 'meta', 'selectedResourceType']);
export const selectedResourceIdSelector						= (state) => state.getIn(['application', 'meta', 'selectedResourceId']);


export const programListFiltersSelector						= (state) => state.getIn(['resources', 'pages', 'programs', 'meta', 'filters'], Immutable.List());
export const programListCategoriesSelector				= (state) => state.getIn(['resources', 'pages', 'programs', 'meta', 'categories'], Immutable.List());
export const programListSelector = require('./programListSelector');
export const programsSelector = require('./programsSelector');

export const titleSelector = require('./titleSelector');
export const applicationStatusCodeSelector = require('./applicationStatusCodeSelector');
export const contextMetricsSelector = require('./contextMetricsSelector');

export const autoCompleteSelector  = require('./autoCompleteSelector');


const ImportantMessageResourceSelector = (state) => resourceSelector(state, { type:'message_lists', id:'important' });
export const ImportantMessageSelector	= createSelector(
	[cacheSelector, ImportantMessageResourceSelector],
	(cache, resource) => {
		return resolveResource(resource, cache, ['messages']).get('messages', Immutable.List());
	}
);



















import resourceIncludeSelector from './resourceIncludeSelector';

const programTeasersResourceSelector = (state) => resourceSelector(state, { type:'teaser_lists', id:'programs_editorials' });
export const resourceStatusSelector = (state, props = {}) => {
	const resource = state.getIn(['resources',`/${props.type}/${props.id}`], Immutable.Map());
	if(resource.get('error')) {return 'RESOURCE_STATUS_ERROR'; }
	if(resource.get('isFetching')) { return 'RESOURCE_STATUS_FETCHING'; }
	return 'RESOURCE_STATUS_CACHED';
};

export const programTeasersSelector	= createSelector(
	[cacheSelector, programTeasersResourceSelector],
	(cache, resource) => resolveResource(resource, cache, ['cover']).get('teasers', Immutable.List())
);

export const articleSelector = createSelector(
	[cacheSelector, resourceSelector, resourceIncludeSelector],
	(cache, resource, include) => resolveResource(resource, cache, include)
);

export const programSelector = createSelector(
	[cacheSelector, resourceSelector, resourceIncludeSelector],
	(cache, resource, include) => resolveResource(resource, cache, include)
);

const frontpageEditorialsResourceSelector = (state) => resourceSelector(state, { type:'teaser_lists', id:'frontpage_editorials' });
const frontpageEditorialsIncluddeSelector = (state) => resourceIncludeSelector(state, { type:'teaser_lists', id:'frontpage_editorials' });
export const bottomTeasersSelector = createSelector(
	[cacheSelector, frontpageEditorialsResourceSelector, frontpageEditorialsIncluddeSelector],
	(cache, resource, include) => {
		const teasers = resolveResource(resource, cache, include).get('teasers', Immutable.List());
		return Immutable.Map().withMutations((map) => {
			return map
				.set('editorials', teasers.slice(9, 13))
				.set('otherEditorials', teasers.slice(13, 21));
		});
	}
);

export const editorialBottomTeasersSelector = createSelector(
	[cacheSelector, frontpageEditorialsResourceSelector, frontpageEditorialsIncluddeSelector],
	(cache, resource, include) => {
		const teasers = resolveResource(resource, cache, include).get('teasers', Immutable.List());
		return Immutable.Map().withMutations((map) => {
			return map
				.set('editorials', teasers.slice(0, 5));
		});
	}
);

export const firstpageSelector = require('./firstpageSelector');



/** WEBPACK FOOTER **
 ** ./app/selectors/index.js
 **/